import React from 'react';

import { Stack } from '@lyearn/ui';
import { FilterOption } from '@/components/Filter/types';

import SelectedWorkspace from './SelectedWorkspace';

type SelectedWorkspacesProps = {
  selectedWorkspaces: FilterOption[];
  onRemove: (id: string) => void;
  disabled: boolean;
};

function SelectedWorkspaces(props: SelectedWorkspacesProps) {
  const { selectedWorkspaces, onRemove, disabled } = props;

  if (!selectedWorkspaces.length) {
    return null;
  }

  return (
    <Stack className="mt-8 flex-wrap" gapX={8} gapY={8}>
      {selectedWorkspaces.map((item) => (
        <SelectedWorkspace
          key={item.value}
          disabled={disabled}
          selectedWorkspace={item}
          onRemove={onRemove}
        />
      ))}
    </Stack>
  );
}

export default SelectedWorkspaces;
